import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'
import Field from 'components/controls/field'
import { validatePasswordWithError, validate } from 'shared/helpers/validate'
import auth from 'utils/auth'
import Storage from 'shared/helpers/storage'
import 'less/change-password-modal.less'

const ChangePasswordModal = props => {
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [passwordValid, setPasswordValid] = useState(true)
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(true)
    const [passwordErrorMessage, setPasswordErrorMessage] = useState("")
    const [confirmPasswordErrorMessage, setconfirmPasswordErrorMessage] = useState("")
    const [resetPasswordClicked, setResetPasswordClicked] = useState(false)
    const [showPasswordError, setPasswordError] = useState(false)
    const [showconfirmPasswordError, setconfirmPasswordError] = useState(false)
    const showMessage = props.showErrorMessage || props.showAcceptTermsMessage
    const userId = props.match.params.id
    const token = props.match.params.token
    const isForgetPassword = window.location.href.indexOf("reset-password") > -1
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleValidation()
        }
    }

    const toggleModal = () => {
        props.closeResetPasswordModal()
        window.location.replace(window.location.origin + "/login");
    }

    const handleValidation = () => {
        if (password.length > 0) {
            setPasswordValid(validate(validatePasswordWithError, password))
            setPasswordErrorMessage(props.t("password.error.message"))
            setPasswordError(!(validate(validatePasswordWithError, password).isValid))
        } else if (password.length === 0) {
            setPasswordValid(validate(validatePasswordWithError, password))
            setPasswordErrorMessage(props.t("required.field"))
            setPasswordError(true)
        }
        if (password.length > 0 && confirmPassword.length > 0 && password !== confirmPassword) {
            setconfirmPasswordErrorMessage(props.t('confirm.password.error'))
            setConfirmPasswordValid({ isValid: false })
            setconfirmPasswordError(true)
        } else if (confirmPassword.length > 0) {
            setConfirmPasswordValid(validate(validatePasswordWithError, confirmPassword))
            setconfirmPasswordErrorMessage(props.t("password.error.message"))
            setconfirmPasswordError(!(validate(validatePasswordWithError, confirmPassword).isValid))
        }
        else if (confirmPassword.length === 0) {
            setconfirmPasswordErrorMessage(props.t("required.field"))
            setconfirmPasswordError(true)
        }
        setResetPasswordClicked(true)
    }

    useEffect(() => {
        if (passwordValid.isValid === true && confirmPasswordValid.isValid === true && !showPasswordError && !showconfirmPasswordError) {
            props.updatePasswordRequest({ userId, password, token, isForgetPassword})
        }
    }, [confirmPasswordValid, passwordValid])

    useEffect(() => {
        if (password.length > 0 || confirmPassword.length > 0) {
            setPasswordError(false)
            setconfirmPasswordError(false)
        }
    }, [confirmPassword, password])

    const handleRedirection = () => {
        toggleModal()
    }

    useEffect(() => {
        Storage.getItem("accessToken") && auth.signOut()
        Storage.clear()
    },[])

    return (
        <Modal
            isOpen={props.isOpen}
            className="change-password-modal"
            title={props.t('change.password.title')}
            submitBtnText={showMessage ? props.t('proceed.btn.text') : props.t('submit.btn.text')}
            onSubmit={showMessage ? toggleModal : handleValidation}
            isSubmitting={props.isLoading}
            showCancelBtn={false}
            cancelable={false}
            enableSubmit={((!showMessage) || (props.status === 200)) ? true : false}
        >
            <div className={`${showMessage ? "accept-terms-" : "reset-password-"}message-container`}>
                <div className={`${showMessage ? "accept-terms-message" : "reset-password"}`}>
                    {props.showErrorMessage ?
                        <div className='message' dangerouslySetInnerHTML={{
                                    __html: props.t('link.expired.error', {
                                        markup: { tagStart: `<a href='' onClick={handleRedirection}>go to login page </a>` }
                                    })
                                }} />
                        : props.showAcceptTermsMessage ? props.t('accept.terms.message') : props.t('reset.password.message')}
                </div>
            </div>
            {!showMessage && <div className={`change-password-container`}>
                <div className="new-password" >
                    <Field
                        type="password"
                        name="open-ended"
                        label="New Password"
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e)}
                    />
                    {(showPasswordError && ((password.length === 0 && resetPasswordClicked) || (password.length > 0 && passwordValid.isValid === false))) &&
                        <div className="form-field-row">
                            <span> {passwordErrorMessage} </span>
                        </div>}
                </div>
                <div className="confirm-password" >
                    <Field
                        type="password"
                        name="open-ended"
                        label="Confirm Password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e)}
                    />
                    {(showconfirmPasswordError && ((confirmPassword.length === 0 && resetPasswordClicked) || (confirmPassword.length > 0 && confirmPasswordValid.isValid === false))) &&
                        <div className="form-field-row">
                            <span> {confirmPasswordErrorMessage} </span>
                        </div>}
                </div>
            </div>
            }

        </Modal >
    )
}

export default ChangePasswordModal
